import { TAction } from '../../../actions/types/action';

const AUTOCOMPLETE_SEARCH = 'AUTOCOMPLETE/SEARCH_REQUEST';
function search(term: string) {
  return { type: AUTOCOMPLETE_SEARCH, payload: { term } };
}

const AUTOCOMPLETE_SUCCESS = 'AUTOCOMPLETE/SEARCH_SUCCESS';
function searchSuccess(results: any[]) {
  return { type: AUTOCOMPLETE_SUCCESS, payload: { results } };
}

const AUTOCOMPLETE_FAILURE = 'AUTOCOMPLETE/SEARCH_FAILURE';
function searchFailure(errorMessage: string) {
  return { type: AUTOCOMPLETE_FAILURE, payload: { errorMessage } };
}

const baseStatusState = {
  loading: false,
  loaded: true,
  error: false
};

const loadingState = { ...baseStatusState, loading: true };
const loadedState = { ...baseStatusState, loaded: true };
const errorState = { ...baseStatusState, error: true };

const initialState = {
  ...baseStatusState,
  term: '',
  results: []
};

export default function autocompleteReducer(state: any = initialState, action: TAction<any>) {
  switch (action.type) {
    case AUTOCOMPLETE_SEARCH: {
      const { term } = action.payload;
      return { ...state, term, ...loadingState };
    }
    case AUTOCOMPLETE_SUCCESS: {
      const { results } = action.payload;
      return { ...state, results, ...loadedState };
    }
    case AUTOCOMPLETE_FAILURE: {
      const { errorMessage } = action.payload;
      return {
        ...state,
        errorMessage,
        ...errorState
      };
    }
    default:
      return state;
  }
}

export const actions = {
  search,
  searchSuccess,
  searchFailure
};

export const actionTypes = {
  AUTOCOMPLETE_SEARCH,
  AUTOCOMPLETE_SUCCESS,
  AUTOCOMPLETE_FAILURE
};
